import { BaseModel } from "./base";

export class UserMinumum extends BaseModel
{
    
    updatedBy: string=null;
    createdBy: CreatedBy = new CreatedBy();
    status: string=null;
    firstName: string=null;
    lastName: string=null;
    title: string=null;
    email: string=null;
    username: string=null;
    password : string = null;
    lastPasswordResetDate: string=null;
    lastLogin: string=null;
    phone: string=null;
    timezone: string=null;
    role: string = 'ADMIN';
    profilePic: string=null;
    showTutorial : string = null;
    searchTags : string = null;
    timeZone : string = null;


    // userType: string="DMS";
}

export class UserImpl extends BaseModel {
    updatedBy : string = null;
    account : Account = new Account();
    createdBy : CreatedBy = new CreatedBy();
    password :  string = null;
    firstName: string = null;
    lastName : string = null;
    title : string = null;
    login : string = null;
    theme : string = null;
    scheme : string = null;
    profilePic : string = null;
    email : string = null;
    phone : string = null;
    timeZone : string = null;
    userType : string = null;
    lastLogin :  string = null;
    status :  userStatus = null;
    username : string = null;
    role : string = 'ADMIN';
    showTutorial : string = null;
    searchTags : string = null;
    lastPasswordRestDate : string = null;
    details : UserDetail = new UserDetail();
    root : string = null;
    eid : string = null;

}

export class CreatedBy  {
     id : string = null;
     firstName: string = null;
     lastName : string = null;
     title : string = null;
     type : string = null;
     name : string = null;
     email : string = null;
     phone : string = null;
     profilePic : string = null;
     active : boolean = false;
  }

export type userStatus= 'ACTIVE' |'DISABLE'|'SUSPENDED'|'DELETED'|'EXPIRED'|'PENDING'|'LOCKED';

export class Account{
    id: string=null;
    name: string=null;
    color?: any=null;
    preferences : AccountPreference = new AccountPreference();
}


export class AccountPreference {
    id : string = null;
    enable2fa : boolean = false;
    changePasswordEverySixMonths : boolean = false;
    communicationAlert : boolean = false;
    securityAlert : boolean = false;
    email : string = null;
    commentAlert : boolean = false;
    deleteItemAlert : boolean = false;
    shareItemWithExternalAlert : boolean = false;

}


export class UserDetail {
    id : string = null;
    language : string = null;
    enable2fa : boolean = false;
    changePasswordEverySixMonths : boolean = false;
    communicationAlert : boolean = false;
    securityAlert : boolean = false;
    commentEmail : boolean = false;
    mentionEmail : boolean = false; 
    assetView : string  =  "LIST";
}
